import type { JSX } from 'react'
import type { ISidebarProps } from '../Sidebar'

import { FIXED_INDENTS } from 'vars/index'
import { Sidebar } from '../Sidebar'
import { SidebarPaddings } from '../Sidebar.h'

export interface IBannerSidebarProps extends ISidebarProps {}

export const BannerSidebar = ({
  children,
  title = '',
  height,
  paddings = SidebarPaddings.SIZE_10,
  rowGap = FIXED_INDENTS.INDENT_40,
  ...rest
}: IBannerSidebarProps): JSX.Element => (
  <Sidebar
    title={title}
    height={height}
    paddings={paddings}
    rowGap={rowGap}
    {...rest}
  >
    {children}
  </Sidebar>
)
